import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isLoggedIn } from '../../../Auth/AuthReducer';

import LayoutFocused from '../LayoutFocused/LayoutFocused';

import styles from './Forbidden.css';

const messages = defineMessages({
  title: {
    id: 'Forbidden.Title',
    defaultMessage: 'Forbidden',
  },
  heading: {
    id: 'Forbidden.Heading',
    defaultMessage: 'Permission denied',
  },
});

function Forbidden(props) {
  const { formatMessage } = props.intl;
  return (
    <LayoutFocused className={styles.container} title={formatMessage(messages.title)}>
      <div>
        <h3>
          <FormattedMessage id="Forbidden.Heading" />
        </h3>
        <div className={styles.body}>
          <div className={styles.error}>403</div>
          <div className={styles.alternatives}>
            <FormattedMessage id="Forbidden.Alternatives" defaultMessage="Now you may want to:" />
            <ul>
              <li>
                <FormattedMessage
                  id="Forbidden.Contact"
                  defaultMessage="Contact the person that provided this link"
                />
              </li>
              {props.loggedIn ? (
                <li>
                  <FormattedMessage
                    id="Forbidden.GoToStart"
                    defaultMessage="Go to the {startingPage}."
                    values={{
                      startingPage: (
                        <Link to="/">
                          <FormattedMessage
                            id="Forbidden.StartingPage"
                            defaultMessage="starting page"
                          />
                        </Link>
                      ),
                    }}
                  />
                </li>
              ) : (
                <li>
                  <FormattedMessage
                    id="Forbidden.TryOurService"
                    defaultMessage="{knowMore} about Promoter Ninja and sign up for free."
                    values={{
                      knowMore: (
                        <Link to="/">
                          <FormattedMessage id="Forbidden.KnowMore" defaultMessage="Know more" />
                        </Link>
                      ),
                    }}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </LayoutFocused>
  );
}

Forbidden.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  loggedIn: isLoggedIn(state),
});

export default connect(mapStateToProps)(injectIntl(Forbidden));
